import actions from './actions'
import { factoryReducer } from '../factory'

// Defining the Initial Variables to be saved in the Redux Store on initialize.
const initialState = {
  loading: false,
  patientList: [],
  dashboardType: 'minInfo', // minInfo = Simple, default = Default and moreInfo = Detailed
  selectedFloor: 'all',
  userSettingsData: {},
}

export default factoryReducer(initialState, actions)
